import {
  CouponType,
  OnSiteLocationType,
  OrderMethod,
  PaymentMethod,
  RefundReason,
} from '../../../../../../services/exports/Constants';

export default {
  title: 'Informations sur la commande',
  sections: {
    driver_info: 'Infos livreur',
    order_info: 'Informations sur la commande',
    price_info: 'Informations de prix',
    adjustments: 'Ajustements',
  },
  order_methods: {
    [OrderMethod.Pickup]: 'Retrait',
    [OrderMethod.Delivery]: 'Livraison',
    [OnSiteLocationType.RoomService]: 'Room service',
    [OnSiteLocationType.TableService]: 'Service à table',
  },
  room_service_location_types: {
    [OnSiteLocationType.RoomService]: {
      details_label: 'Numéro de chambre',
    },
    [OnSiteLocationType.TableService]: {
      details_label: 'Numéro de table',
    },
  },
  labels: {
    wolt_support: 'Numéro de support Wolt : {{phone_number}}',
    wolt_support_text:
      "Pour toute question sur la commande, le livreur ou des problèmes, appelez Wolt. Précisez bien qu'il s'agit d'une commande <strong>Wolt Drive</strong>",
    dummy_order: 'Commande test',
    asap: 'ASAP',
    driver_name: 'Nom du livreur',
    driver_phone_number: 'Téléphone du livreur',
    pin_code: 'PIN',
    dropoff_pin_code: 'PIN de livraison',
    original: 'Original',
    delivery_fee: 'Frais de livraison',
    tip: 'Pourboire',
    service_fee: 'Traitement en ligne',
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'Frais PayPal',
    },
    promo_applied: {
      default: 'Promo appliquée',
      [CouponType.Reward]: 'Points fidélité appliqués',
      [CouponType.Cashback]: 'Points fidélité appliqués',
      [CouponType.PromoCode]: 'Promo appliquée',
      [CouponType.GiftCard]: 'Carte cadeau appliquée',
    },
    tax: 'Taxes',
    total: 'Total',
    online_payment: "Le client a déjà payé dans l'app {{provider}}",
    cash_payment: 'Paiement sur place',
    invoice_payment: 'Paiement par facture',
    old_order: 'Cette commande a été exécutée avec succès',
    pickup_time: 'Heure de retrait',
    pickup_asap: 'Le client demande le retrait le plus rapide possible.',
    points_used: 'Cette commande inclut une récompense en points fidélité utilisée par un client fidèle',
    order_instructions: 'Instructions de commande :',
    today: "aujourd'hui",
  },
  schedule: {
    header: 'Prévu le {{date}} à {{time}}',
    text: 'Nous vous rappellerons quand il sera temps de préparer la commande',
  },
  adjustment_reasons: {
    [RefundReason.RequestedByCustomer]: 'Demandé par le client',
    [RefundReason.Reclamation]: 'Réclamation',
    [RefundReason.CommunicationError]: 'Erreur de communication',
    [RefundReason.Other]: 'Autre',
    [RefundReason.Dispute]: 'Litige client',
    dispute_win: 'Litige client gagné',
    null: '',
  },
  toasts: {
    print_one: 'Impression de {{count}} reçu : Commande <strong>#{{orderNumber}}</strong>...',
    print_other: 'Impression de {{count}} reçus : Commande <strong>#{{orderNumber}}</strong>...',
    refund_successful: 'Remboursement réussi : Commande <strong>#{{orderNumber}}</strong>...',
  },
  buttons: {
    print: 'Imprimer',
    confirm: 'Confirmer',
    reject: 'Refuser',
    refund: 'Rembourser',
  },
};
